export default {
  cancel: 'Cancelar',
  save: 'Continuar'
}

export const en = {
  cancel: 'Cancel',
  save: 'Continue'
}

export const ca = {
  cancel: 'Cancelar',
  save: 'Continuar'
}
